import { render } from "./EmploymentDetails.vue?vue&type=template&id=a243fd12"
import script from "./EmploymentDetails.vue?vue&type=script&lang=js"
export * from "./EmploymentDetails.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.22_vue@3.5.22_typescript@4.1.6__webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__